import { useState, useEffect } from "react";
import { getTrackBackground, Range } from "react-range";

export default function Rangenumber({ setMinvalue, setMaxvalue }) {
  const STEP = 1;
  const [values, setValues] = useState([0, 10000]);
  const min = 0;
  const max = 10000;
  return (
    <>
      <Range
        values={values}
        step={STEP}
        min={min}
        max={max}
        onChange={val => {
          setValues(val);
          setMinvalue(val[0]);
          setMaxvalue(val[1]);
        }}
        renderTrack={({ props, children }) => (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: "36px",
              display: "flex",
              width: "100%"
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: "5px",
                width: "100%",
                borderRadius: "4px",
                background: getTrackBackground({
                  values,
                  colors: ["#ccc", "#548BF4", "#ccc"],
                  min: min,
                  max: max
                }),
                alignSelf: "center"
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, isDragged }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: "42px",
              width: "42px",
              borderRadius: "4px",
              backgroundColor: "#FFF",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // boxShadow: "0px 2px 3px #AAA"
            }}
            className="round"
          >
            <div
              style={{
                height: "5px",
                width: "2px",
                backgroundColor: isDragged ? "#548BF4" : "#CCC"
              }}
              className="insideround"
            />

          </div>
        )}
      />
      <div className="text-center">
        <span className="text-white">Min : {values[0]}</span>||
        <span className="text-white">Max : {values[1]}</span>
      </div>
    </>
  );
};

